import React from "react";
import { authenticationService } from '_services';

const LineLiffQuery = (props) => {
    var query = (props.location.search != null && props.location.search != undefined && props.location.search != '')
        ? props.location.search.replace('?id=', '')
        : null;

    const liffId = { confirm: '1654063801-JpnXVx2a', tele: '1654063801-PwXBy90W', profile: '1654063801-mPYn4Dba' }

    const liff = window.liff;
    liff.init({
        liffId: '1654063801-JpnXVx2a'
    })
    .then(() => {
        if (liff.isLoggedIn()) {
            liff.getProfile().then(function (profile) {
                authenticationService.login(profile.userId, profile.userId)
                    .then(
                        user => {
                            if (user.isActive == 1) {
                                //const { from } = props.location.state || { from: { pathname: '/payment/' + query } };
                                //props.history.push(from);
                                var host = '/payment/'
                                const queryString = decodeURIComponent(window.location.search).replace("?liff.state=", "");
                                const params = new URLSearchParams(queryString);
                                const id = params.get('id');             
                                
                                if (id != null && id != '') {
                                    window.location.assign(host + id);
                                } else {
                                    window.location.assign("https://developers.line.biz");
                                }             
                            }
                            else {
                                const { from } = props.location.state || { from: { pathname: "/profile/" + liffId.tele } };
                                props.history.push(from);
                            }
                            
                        },
                        error => {
                            const { from } = props.location.state || { from: { pathname: "/lineregister" } };
                            props.history.push(from);
                        }
                    );

            }).catch(function (error) {
                //window.alert('Error getting profile: ' + error);
            });
        }
        else {
            var host = '/payment/'
            const queryString = decodeURIComponent(window.location.search).replace("?liff.state=", "");
            const params = new URLSearchParams(queryString);
            const id = params.get('id');
 
            if (id != null && id != '') {
                window.location.assign(host + id);
            } else {
                window.location.assign("https://developers.line.biz");
            }
        }
        
    })
    .catch((err) => {

    });


  return (
      <>

	<img
              alt="..."
              src={require("assets/img/ts_logo_xl.png")}
              style={{
                  maxHeight: '100%',
                  maxWidth: '100%',
                  width: 'auto',
                  height: 'auto',
                  position: 'absolute',
                  top: 0,
                  bottom: 0,
                  left: 0,
                  right: 0,
                  margin: 'auto',
              }}
      >
          </img>

    </>
  );
}

export default LineLiffQuery;
